var request = require('./request');
var config = require('./config');
var resolve = require('./resolve');
var Promise = require('bluebird');

exports.GetReport = function(qry) {
  return request.post(resolve(config.url(), 'gereports/report'),qry).buffer().promise()
}

exports.GetReportFields = function(id) {
  return request.get(resolve(config.url(), 'gereports/' + id + '/reportfields')).promise()
}

exports.GetReportsByType = function(type) {
  return request.get(resolve(config.url(), 'gereports?type=' + type)).promise()
}

exports.GetReportFieldsByName = function(name) {
  return request.get(resolve(config.url(), 'gereports/reportname?name=' + name)).promise()
}
